// Les liens d'un club (D-104) : son sous-domaine quand il a une adresse, sinon l'adresse actuelle.
// L'adresse (clubs.public_slug) est lue une fois par club et par visite.
import { supabase } from './supabase';
import { clubLinks, type ClubLinks } from '../domain/links';

const HOST_BASE = (import.meta.env.VITE_CLUB_HOST_BASE as string | undefined)?.trim() || null;
const slugs = new Map<string, Promise<string | null>>();

async function readSlug(clubId: string): Promise<string | null> {
  if (!supabase) return null;
  const { data, error } = await supabase.from('clubs').select('public_slug').eq('id', clubId).maybeSingle();
  return error ? null : ((data as { public_slug: string | null } | null)?.public_slug ?? null);
}

export async function linksFor(clubId: string | null | undefined): Promise<ClubLinks> {
  let slug: string | null = null;
  if (clubId) {
    if (!slugs.has(clubId)) slugs.set(clubId, readSlug(clubId).catch(() => null));
    slug = await slugs.get(clubId)!;
  }
  return clubLinks(slug, HOST_BASE, location);
}
